import { useMemo } from "react";
import { isArray } from "lodash";

import { useDealUserRoleSelect } from "store";
import { IRoleName } from "store/types";

export function useDealRoleGuard<T>(data: T, availableRoles: IRoleName | IRoleName[], forbid?: boolean): T | undefined {
  const role = useDealUserRoleSelect();

  return useMemo(() => {
    // Users aren't limited if there is no deal_role
    if (!role) return data;
    if (forbid) return undefined;

    if (typeof availableRoles === "string" && role === availableRoles) {
      return data;
    }

    if (isArray(availableRoles) && availableRoles.includes(role)) {
      return data;
    }

    return undefined;
  }, [data, availableRoles, role, forbid]);
}
